import { render } from "./Main.vue?vue&type=template&id=1677d706"
const script = {}

import exportComponent from "D:\\genx_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__